import React from "react";
import { createRoot } from "reactdom";
import TabsBlock from "../components/TabsBlock";

const renderTabsBlock = ($) => {
	const tabsBlock = $(".js-tabs-block").toArray();

	if (!tabsBlock || !tabsBlock.length) return;

	tabsBlock.forEach((element) => {

		let props = {
			...(element && element.dataset),
		};

		const root = createRoot(element);
		root.render(<TabsBlock {...props} />);
	});
};
export default renderTabsBlock;

